export default {
  home: '/'
};
